import { configureStore } from "@reduxjs/toolkit";

import chartTypeReducer from "./chartTypeSlice";
import seriesReducer from "./seriesSlice";
import axisReducer from "./axisSlice";
import axisTitleReducer from "./axisTitleSlice";
import chartTitleReducer from "./chartTitleSlice";
import dataLabelReducer from "./dataLabelSlice";
import gridReducer from "./gridSlice";

export const store = configureStore({
  reducer: {
    chartType: chartTypeReducer,
    series: seriesReducer,
    axis: axisReducer,
    axisTitle: axisTitleReducer,
    chartTitle: chartTitleReducer,
    dataLabel: dataLabelReducer,
    grid: gridReducer,
  },
});
